// frontend/src/pages/produtos/CatalogoPage.jsx
import { useState, useEffect } from "react";
import Topbar from "../../components/Topbar";
import Modal from "../../components/Modal";
import api from "../../services/api";

export default function CatalogoPage() {
  const [catalogos, setCatalogos]   = useState([]);
  const [produtos, setProdutos]     = useState([]);
  const [loading, setLoading]       = useState(true);
  const [modalNovo, setModalNovo]   = useState(false);
  const [modalLinks, setModalLinks] = useState(null);
  const [links, setLinks]           = useState(null);
  const [etapa, setEtapa]           = useState(1);
  const [form, setForm]             = useState({
    nome: "", descricao: "", publico: true,
    exibir_preco: true, exibir_codigo: false,
    cor_primaria: "#2563eb", texto_rodape: "", validade: "",
  });
  const [selecionados, setSelecionados] = useState([]);
  const [salvando, setSalvando]         = useState(false);

  const carregar = () => {
    setLoading(true);
    api.get("/produtos/catalogos/")
      .then(r => setCatalogos(r.data.results || r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    carregar();
    api.get("/produtos/?page_size=500&categoria=PRODUTO_FINAL")
      .then(r => setProdutos(r.data.results || r.data));
  }, []);

  const abrirLinks = async (cat) => {
    setModalLinks(cat);
    try {
      const r = await api.get(`/produtos/catalogos/${cat.id}/links/`);
      setLinks(r.data);
    } catch { setLinks(null); }
  };

  const salvar = async () => {
    if (!form.nome) return alert("Informe o nome do catálogo.");
    if (!selecionados.length) return alert("Selecione pelo menos 1 produto.");
    setSalvando(true);
    try {
      const res = await api.post("/produtos/catalogos/", form);
      const catId = res.data.id;
      await api.post(`/produtos/catalogos/${catId}/adicionar_produtos/`, {
        produto_ids: selecionados,
      });
      carregar();
      setModalNovo(false);
      setEtapa(1);
      setForm({ nome:"",descricao:"",publico:true,exibir_preco:true,exibir_codigo:false,cor_primaria:"#2563eb",texto_rodape:"",validade:"" });
      setSelecionados([]);
    } catch { alert("Erro ao criar catálogo."); }
    finally { setSalvando(false); }
  };

  const excluir = async (id) => {
    if (!window.confirm("Desativar este catálogo?")) return;
    await api.delete(`/produtos/catalogos/${id}/`);
    carregar();
  };

  const copiar = (url) => { navigator.clipboard.writeText(url); alert("Link copiado!"); };

  const toggleSel = (id) =>
    setSelecionados(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id]);

  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <>
      <Topbar title="Catálogos" />
      <div className="erp-content">
        <div className="page-toolbar">
          <button className="btn btn-primary" onClick={() => setModalNovo(true)}>
            <i className="ti ti-plus" /> Novo catálogo
          </button>
        </div>

        {loading ? (
          <div className="table-empty">Carregando...</div>
        ) : catalogos.length === 0 ? (
          <div className="card" style={{ padding: 40, textAlign: "center", color: "var(--z-text-muted)" }}>
            <i className="ti ti-book" style={{ fontSize: 32, display: "block", marginBottom: 8 }} />
            <p>Nenhum catálogo criado ainda.</p>
            <button className="btn btn-primary" style={{ marginTop: 12 }} onClick={() => setModalNovo(true)}>
              Criar primeiro catálogo
            </button>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px,1fr))", gap: 12 }}>
            {catalogos.map(cat => (
              <div key={cat.id} className="card" style={{ padding: 16 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                  <div style={{ width: 10, height: 10, borderRadius: "50%", background: cat.cor_primaria || "#2563eb" }} />
                  <strong style={{ fontSize: 14 }}>{cat.nome}</strong>
                </div>
                {cat.descricao && <p style={{ fontSize: 12, color: "var(--z-text-muted)", marginBottom: 8 }}>{cat.descricao}</p>}
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
                  <span className={`badge ${cat.publico ? "badge-green" : "badge-gray"}`}>
                    {cat.publico ? "Público" : "Privado"}
                  </span>
                  <span className="badge badge-blue">
                    <i className="ti ti-package" style={{ marginRight: 3 }} />
                    {cat.total_produtos || (cat.itens || []).length} produtos
                  </span>
                  {cat.validade && (
                    <span className="badge badge-amber">Válido até {cat.validade}</span>
                  )}
                </div>
                <div style={{ fontSize: 11, color: "var(--z-text-muted)", marginBottom: 10 }}>
                  <i className="ti ti-eye" style={{ marginRight: 4 }} />{cat.visualizacoes || 0} visualizações
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <button className="btn btn-primary" style={{ flex: 1, fontSize: 12 }} onClick={() => abrirLinks(cat)}>
                    <i className="ti ti-share" /> Compartilhar
                  </button>
                  <button className="btn btn-danger" style={{ padding: "4px 10px" }} onClick={() => excluir(cat.id)}>
                    <i className="ti ti-trash" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal novo catálogo */}
      {modalNovo && (
        <Modal
          title={`Novo catálogo — Etapa ${etapa}/2`}
          onClose={() => { setModalNovo(false); setEtapa(1); }}
          size="lg"
          footer={
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <button className="btn btn-secondary" onClick={() => { setModalNovo(false); setEtapa(1); }}>Cancelar</button>
              <div style={{ display: "flex", gap: 8 }}>
                {etapa === 2 && <button className="btn btn-secondary" onClick={() => setEtapa(1)}>← Voltar</button>}
                {etapa === 1
                  ? <button className="btn btn-primary" onClick={() => setEtapa(2)} disabled={!form.nome}>Próximo →</button>
                  : <button className="btn btn-primary" onClick={salvar} disabled={salvando || !selecionados.length}>
                    {salvando ? "Criando..." : `Criar catálogo (${selecionados.length} produtos)`}
                  </button>
                }
              </div>
            </div>
          }>

          {etapa === 1 ? (
            <div className="form-grid">
              <div className="form-group" style={{ gridColumn: "span 2" }}>
                <label className="form-label">Nome do catálogo *</label>
                <input className="form-input" value={form.nome} placeholder="Ex: Varais Residenciais 2025"
                  onChange={e => setF("nome", e.target.value)} />
              </div>
              <div className="form-group" style={{ gridColumn: "span 2" }}>
                <label className="form-label">Descrição</label>
                <textarea className="form-input" rows={2} value={form.descricao}
                  placeholder="Breve descrição do catálogo..."
                  onChange={e => setF("descricao", e.target.value)} />
              </div>
              <div className="form-group" style={{ gridColumn: "span 2" }}>
                <label className="form-label">Texto do rodapé</label>
                <input className="form-input" value={form.texto_rodape}
                  placeholder="Ex: Zephir Varais · (11) 99999-0000"
                  onChange={e => setF("texto_rodape", e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Cor principal</label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <input type="color" value={form.cor_primaria}
                    onChange={e => setF("cor_primaria", e.target.value)}
                    style={{ width: 40, height: 36, borderRadius: 6, cursor: "pointer", border: "1px solid var(--z-border)" }} />
                  <span style={{ fontSize: 12, color: "var(--z-text-muted)" }}>{form.cor_primaria}</span>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Válido até</label>
                <input type="date" className="form-input" value={form.validade}
                  onChange={e => setF("validade", e.target.value)} />
              </div>
              <div className="form-group" style={{ gridColumn: "span 2", display: "flex", flexDirection: "column", gap: 8 }}>
                {[
                  { key: "publico",       label: "Catálogo público (link aberto)" },
                  { key: "exibir_preco",  label: "Exibir preços" },
                  { key: "exibir_codigo", label: "Exibir código do produto" },
                ].map(({ key, label }) => (
                  <label key={key} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13 }}>
                    <input type="checkbox" checked={form[key]}
                      onChange={e => setF(key, e.target.checked)}
                      style={{ width: 16, height: 16 }} />
                    {label}
                  </label>
                ))}
              </div>
            </div>
          ) : (
            <div>
              <p style={{ fontSize: 12, color: "var(--z-text-muted)", marginBottom: 10 }}>
                Selecione os produtos — {selecionados.length} selecionado(s)
              </p>
              <div style={{ maxHeight: 380, overflowY: "auto", display: "flex", flexDirection: "column", gap: 4 }}>
                {produtos.map(p => (
                  <label key={p.id} style={{
                    display: "flex", alignItems: "center", gap: 10, padding: "8px 10px",
                    borderRadius: 6, cursor: "pointer", border: "1px solid",
                    borderColor: selecionados.includes(p.id) ? "var(--z-blue)" : "var(--z-border)",
                    background: selecionados.includes(p.id) ? "#eff6ff" : "transparent",
                    transition: "all 0.1s",
                  }}>
                    <input type="checkbox" checked={selecionados.includes(p.id)}
                      onChange={() => toggleSel(p.id)} style={{ width: 15, height: 15 }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 500 }}>{p.nome}</div>
                      <div style={{ fontSize: 11, color: "var(--z-text-muted)" }}>{p.codigo}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}
        </Modal>
      )}

      {/* Modal links */}
      {modalLinks && (
        <Modal title="Compartilhar catálogo" onClose={() => { setModalLinks(null); setLinks(null); }} size="md"
          footer={<button className="btn btn-secondary" onClick={() => { setModalLinks(null); setLinks(null); }}>Fechar</button>}>
          <p style={{ fontWeight: 600, marginBottom: 12 }}>{modalLinks.nome}</p>
          {!links ? (
            <div style={{ textAlign: "center", color: "var(--z-text-muted)" }}>Carregando links...</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div>
                <label className="form-label">Link público</label>
                <div style={{ display: "flex", gap: 8 }}>
                  <input readOnly className="form-input" value={links.link_publico} style={{ fontSize: 12 }} />
                  <button className="btn btn-secondary" onClick={() => copiar(links.link_publico)}>
                    <i className="ti ti-copy" />
                  </button>
                  <a href={links.link_publico} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                    <i className="ti ti-external-link" />
                  </a>
                </div>
              </div>
              <a href={links.whatsapp} target="_blank" rel="noopener noreferrer"
                className="btn" style={{ background: "#22c55e", color: "#fff", justifyContent: "center" }}>
                <i className="ti ti-brand-whatsapp" /> Enviar pelo WhatsApp
              </a>
              <div>
                <label className="form-label">Link privado (com token)</label>
                <div style={{ display: "flex", gap: 8 }}>
                  <input readOnly className="form-input" value={links.link_privado} style={{ fontSize: 11 }} />
                  <button className="btn btn-secondary" onClick={() => copiar(links.link_privado)}>
                    <i className="ti ti-copy" />
                  </button>
                </div>
              </div>
            </div>
          )}
        </Modal>
      )}
    </>
  );
}
